
export interface DateObject {
    year: number;
    month: number;
    day: number;
  }
  
  export interface optionGetTodayDate {
    currentDate?: string;
    nbDay?: number;
    nbMonth?: number;
    nbYear?: number;
    resetHour?: boolean;
    resetMinute?: boolean;
    resetDay?: boolean;
    nbHour?: number;
    resetMonth?: boolean;
  
  }
  export const getTodayDate = (option?: optionGetTodayDate) => {
    const date =  option?.currentDate? new Date(option.currentDate) : new Date();
  
    if (option?.resetHour) {
      date.setUTCHours(0, 0, 0, 0);
    }
  
    if (option?.resetMinute) {
      date.setUTCMinutes(0, 0, 0);
    }
  
    if (option?.resetDay) {
      date.setUTCDate(1);
    }
  
    if(option?.resetMonth) {
      date.setUTCMonth(0);
      date.setUTCDate(1);
      date.setUTCHours(0, 0, 0, 0);
      date.setUTCMinutes(0, 0, 0);
    }
    
    if (option?.nbHour) {
      date.setUTCHours(date.getUTCHours() + option.nbHour);
    }
    
  
  
    if (option?.nbDay) {
      date.setUTCDate(date.getUTCDate() + option.nbDay);
    }
  
    if (option?.nbMonth) {
      date.setUTCMonth(date.getUTCMonth() + option.nbMonth);
    }
  
    if (option?.nbYear) {
      date.setUTCFullYear(date.getUTCFullYear() + option.nbYear);
  
    }
  
  
  
  
    return date.toISOString();
  }